<template>
  <v-container class="mt-5">
    <v-card
      class="px-2 pb-2">
      <v-row>
        <v-col>
          <p>Modelo de Coparticipação - Novo Registro</p>
        </v-col>
        <v-col cols="3" class="d-flex flex-row justify-end">
          <v-btn class="mr-1" small @click="save">
            <v-icon small title="Create">fas fa-save</v-icon>
          </v-btn>
          <v-btn small @click="$refs.form.goBack()">
            <v-icon small title="Voltar">fas fa-arrow-circle-left</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-4"></v-divider>

      <v-container fluid>
        <v-row>
          <v-col>
            <ShareModelForm ref="form" :errors="errors" :share-model="shareModel"></ShareModelForm>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import {mapErrors} from "@/common/validation";
import {mapActions, mapMutations} from "vuex";
import ShareModelForm from "@/view/share_model/_share_model_form"

export default {
  components: { ShareModelForm },
  data() {
    return {
      errors: {},
      shareModel: {
        code: null,
        description: null,
        active: true
      }
    };
  },
  methods: {
    ...mapActions("shareModel", ["createShareModel"]),
    ...mapMutations(["toogleDialogLoading"]),
    save() {
      if(!this.$refs.form.validate()) {
        return;
      }
      this.toogleDialogLoading(true);
      this.errors = {}

      this.createShareModel(this.$refs.form.model())
          .then(data => {
            this.$router.push(`/share_model/${data.id}/show`)
          }).catch((error) => {
            const errors = [];
            if(error.response.status==409){
              errors.push({field:'code',defaultMessage:error.response.data});
            }
            this.errors = mapErrors(this.$refs.form.model(), errors)
          })
          .finally(() => {
            this.toogleDialogLoading(false);
          });
    }
  },
};
</script>


